"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
const CustomState_1 = tslib_1.__importDefault(require("./CustomState"));
const ForbiddenState = (props) => {
    const { icon = 'rioglyph-ban-circle' } = props, remainingProps = tslib_1.__rest(props, ["icon"]);
    return (0, jsx_runtime_1.jsx)(CustomState_1.default, Object.assign({ icon: icon }, remainingProps));
};
exports.default = ForbiddenState;
